<template>
<div>
    <app-header></app-header>
    <div class="container-fluid">
      <div class="row my-3">
        
        <div class="col-lg-12 col-md-12">
        <button type="button" style="font-size: 16px" class="btn btn-outline-primary btn mr-3" @click="backToProjects()"><i class="fas fa-chevron-left mr-2"></i>{{caption("winlist_Back")}}</button>
        </div>
        </div>
        <div class="h3 mb-4 display-4">Updates</div>
        <div v-for="vn in getVNList" v-bind:key="vn">
          <div class="h4"><strong>{{vn}}</strong></div>
          <div v-for="version in versions.filter(v=>v.vn == vn)" v-bind:key="version.Id">
              <div class="row my-1">
                  <div class="col-lg-12 col-md-12">
                      {{lang == 'NED' ? version.ned : version.eng}}
                  </div>
              </div>
          </div>
          <hr/>
        </div>
    </div>
</div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from '../../ClientApp/store';
import { mapGetters } from "vuex";

export default {
  data: function () {
    return {
      error: null,
      versionsloaded: false,
    };
  },
  components: {
    AppHeader
  },
  computed: {
      versions(){
        var u = this.$store.state.versions;
          return u;
      },
      lang(){
        var l = this.$store.getters.getLanguage;
        return l;
      },
      ...mapGetters(['getSysco', 'getVNList'])
  },
  methods:{
      backToProjects(){
        this.$router.push("/projects/0");
      },
      caption(term){
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    }
  },
  
  mounted() {
    this.$store.dispatch("getVersions")
    .then(response => {
      this.versionsloaded = true;
    });
  },
}
</script>

<style scoped>
    @media (min-width: 1500px) {
        .container-fluid {
        width: 80%;
        }
    }
    @media (min-width: 2000px) {
        .container-fluid {
        width: 60%;
        }
    }
    

    .lnk{
      cursor:pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/versions/VersionList.vue